export type ChartViewMode = 'deviceView' | 'networkView' | 'comparisonView';

const SET_CHART_VIEW_MODE = 'SET_CHART_VIEW_MODE';

export const setChartViewMode = (viewMode: ChartViewMode) => ({
  type: SET_CHART_VIEW_MODE,
  payload: viewMode,
});
